import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../components/header'
import Footer from '../../components/footer'
import Head from '../../components/head';
import Solicitar from '../../components/publico/solicitar'

function SolicitarScreen() {
        return (
            <Fragment>
                <Head titulo="Monte sua configuração | Departamento de TI" />
                <HeaderLogged />
                <Container>
                   <Solicitar />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default SolicitarScreen;